import React, { createContext, useContext } from 'react';
import { TargetLayerArea } from 'rwl-shared/dist/models/analytics';

interface AnalyticsTargetLayerAreaProviderProps {
    targetLayerArea?: TargetLayerArea;
}

interface AnalyticsTargetLayerAreaContextType {
    targetLayerArea?: TargetLayerArea;
}

const AnalyticsTargetLayerAreaContext = createContext<
    AnalyticsTargetLayerAreaContextType | undefined
>(undefined);

export const AnalyticsTargetLayerAreaProvider: React.FC<
    AnalyticsTargetLayerAreaProviderProps
> = ({ targetLayerArea: area, children }) => {
    return (
        <AnalyticsTargetLayerAreaContext.Provider
            value={{ targetLayerArea: area }}
        >
            {children}
        </AnalyticsTargetLayerAreaContext.Provider>
    );
};

export const useAnalyticsTargetLayerArea =
    (): AnalyticsTargetLayerAreaContextType => {
        const context = useContext(AnalyticsTargetLayerAreaContext);
        if (!context) {
            throw new Error(
                'useAnalyticsTargetLayerArea must be used within an AnalyticsTargetLayerAreaProvider'
            );
        }
        return context;
    };
